import script from "./OrderLtvV2View.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderLtvV2View.vue?vue&type=script&setup=true&lang=js"

import "./OrderLtvV2View.vue?vue&type=style&index=0&id=523a7148&scoped=true&lang=css"
import "./OrderLtvV2View.vue?vue&type=style&index=1&id=523a7148&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523a7148"]])

export default __exports__